import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateStepsStahltreppe,
        updatePodest,
        updatePodestWidth
        } from '../../../../store/actions/stahltreppen';
import {InputRadio} from '../../../../module/inputRadio';
import {Textfield} from '../../../../module/textField';
import scrollToElement from '../../../../module/scrollToElement';



const Step_5 = (props) => {
    const [isPodest, selectPodest] = useState('');
    const [podestWidth, updatePodestWidth] = useState('');


   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
        const {isPodest, podestWidth} = props.data.podest[0];

        selectPodest(isPodest);
        updatePodestWidth(podestWidth);

        //update steps
        props.updateSteps(3);

        //scroll to Next Button Container
        if (isPodest === 'ja') scrollToElement();

        if(isPodest === 'nein' || podestWidth > 0 || props.data.allVisitedSteps) {
            props.updateSteps(4);
            props.setUpdateButtonActiveStepToFalse();
        } else {
            props.setUpdateButtonActiveStepToTrue()
        }
   }

   const updatePodest = ev => {
       let isPodest = ev.target.value;
       props.updatePodest(isPodest);
       updateItems();
   }

   const arrayRadioItems = [
       {labalValue: 'ja', labelTitel: 'Ja'},
       {labalValue: 'nein', labelTitel: 'Nein'}
   ]

   const selectPodestWidth = ev => {
       let podestWidth = ev.target.value;
       props.updatePodestWidth(podestWidth);
       updateItems();
   }


    return (
        <div className="step_wrapper">
            <h2 className='step_header'>Brauchen Sie ein Podest?</h2>
              <div className="step_icon_wrapper">
                <div className="inner_textfield_wrapper podest">
                    <InputRadio
                        onChange={updatePodest}
                        value={isPodest}
                        name='podest'
                        arrayRadioItems={arrayRadioItems}
                    />
                </div>
            {isPodest === 'ja'?
            <>
                 <h2 className='step_header'>Podestlänge</h2>
                 <div className="inner_textfield_wrapper">
                     <Textfield
                         label='Bitte wählen (in cm)'
                         type='number'
                         rowsMax={1}
                         value={podestWidth}
                         onChange={selectPodestWidth}
                     />
                 </div>
            </>:''
            }

            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        data: state.stahltreppenReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsStahltreppe(ev)),
      updatePodest: ev => dispatch(updatePodest(ev)),
      updatePodestWidth: ev => dispatch(updatePodestWidth(ev))

   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_5);
